import React from "react";

const gradeColor = {
    "A+": "#1B6F1B",
    "A": "#2A8C2A",
    "B": "#B5811F",
    "C": "#B05015",
    "F": "#8A0303",
};

export const Polaroid = ({ photo, fx, room, aiImageUrl, aiLoading }) => {
    const blur = (fx?.blur ?? 0) + (fx?.dofBlur ?? 0);
    const brightness = fx?.brightness ?? 1;
    const noise = fx?.noise ?? 0;

    return (
        <div className="polaroid w-full max-w-xs" data-testid="polaroid-result">
            <div
                className="relative w-full aspect-[4/3] overflow-hidden bg-black"
                style={{
                    filter: aiImageUrl ? "none" : `blur(${blur}px) brightness(${brightness})`,
                }}
            >
                {aiImageUrl ? (
                    <img
                        src={aiImageUrl}
                        alt={`Developed photograph from ${room?.name}`}
                        className="absolute inset-0 w-full h-full object-cover"
                        data-testid="polaroid-ai-image"
                    />
                ) : (
                    <>
                        <div
                            className="absolute inset-0"
                            style={{
                                background: `radial-gradient(ellipse at 50% 55%, rgba(255,59,0,0.4), #0a0606 75%)`,
                            }}
                        />
                        <div className="absolute inset-0 flex items-center justify-center text-amber-glow font-display text-4xl opacity-80">
                            {room?.id === "locked_cabinet" ? "🔑" : room?.id === "phantom" ? "👻" : "◉"}
                        </div>
                        {noise > 0.1 && (
                            <div className="scene-noise absolute inset-0" style={{ opacity: noise }} />
                        )}
                    </>
                )}
                {aiLoading && (
                    <div
                        className="absolute inset-0 flex items-center justify-center bg-black/70 text-amber font-mono text-[10px] tracking-[0.3em] uppercase"
                        data-testid="polaroid-ai-loading"
                    >
                        ⏳ Developing...
                    </div>
                )}
            </div>
            <div className="mt-3 flex items-center justify-between text-[10px] uppercase tracking-widest">
                <span>{room?.name}</span>
                <span
                    className="px-2 py-0.5 font-bold text-white"
                    style={{ background: gradeColor[photo.grade] || "#444" }}
                    data-testid="polaroid-grade"
                >
                    {photo.grade}
                </span>
            </div>
            <div className="mt-1 text-[9px] tracking-widest opacity-70">
                {photo.aperture} · {photo.shutter} · ISO {photo.iso}
            </div>
        </div>
    );
};

export default Polaroid;
